"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.assign.js");
var _react = _interopRequireDefault(require("react"));
var _CustomCircleModule = _interopRequireDefault(require("../../styles/components/Circles/CustomCircle.module.css"));
var _Circles = _interopRequireDefault(require("./Circles"));
var _Timestamp = _interopRequireDefault(require("./Timestamp"));
var _Value = _interopRequireDefault(require("./Value"));
var _CircleTitle = _interopRequireDefault(require("./CircleTitle"));
var _constants = require("../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const CustomCircle = _ref => {
  let {
    thingPDIDDevice,
    displayNameId,
    hasPositionValue = false,
    hover = false,
    title = '',
    circleParams = {
      type: _constants.circleType.power,
      isCorrectValue: true
    },
    isCorrectValue = true
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_CustomCircleModule.default.container, " flex-center")
  }, /*#__PURE__*/_react.default.createElement(_Circles.default, _extends({
    thingPDIDDevice: thingPDIDDevice,
    displayNameId: displayNameId
  }, circleParams)), /*#__PURE__*/_react.default.createElement("div", {
    className: _CustomCircleModule.default.info
  }, hasPositionValue && /*#__PURE__*/_react.default.createElement(_CircleTitle.default, {
    displayNameId: displayNameId,
    hover: hover,
    title: title
  }), /*#__PURE__*/_react.default.createElement(_Value.default, {
    thingPDIDDevice: thingPDIDDevice,
    isCorrect: isCorrectValue,
    displayNameId: displayNameId
  }), /*#__PURE__*/_react.default.createElement(_Timestamp.default, {
    thingPDIDDevice: thingPDIDDevice,
    isCorrect: isCorrectValue,
    displayNameId: displayNameId,
    hover: hover
  })));
};
var _default = exports.default = CustomCircle;